module.exports = __webpack_public_path__ + "img/noresult.5357d4ba.png";